module.exports = __webpack_public_path__ + "img/gy2.5e9689e2.png";